var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row.isUrl)?_c('a',{attrs:{"rel":"nofollow noopener noreferrer","target":"_blank","href":("" + (_vm.row.fullPath))}},[_vm._v(_vm._s(_vm.row.fullPath))]):_c('span',[_vm._v(_vm._s(_vm.row.fullPath))])}
var staticRenderFns = []

export { render, staticRenderFns }